import React from "react";
import ChartGoal from "charts/ChartGoal";
import ChartLine from "charts/ChartLine";
import ChartPie from "charts/ChartPie";
import ChartBar from "charts/ChartBar";
import ChartLocation from "charts/ChartLocation";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BlueIndentedSection from "dashboards/BlueIndentedSection";
import KPIMetricBlock from "dashboards/KPIMetricBlock";
import GetFormatter from "dashboards/GetFormatter";
import MetricFormatter from "dashboards/MetricFormatter";
import MetricTable from "MetricTable";
import ServiceDisabled from "dashboards/ServiceDisabled";
import NoData from "dashboards/NoData";
import jsDig from "utils/jsDig";
import allMetrics from "data/allMetrics.js";
import { camelCase } from "lodash-es";
import getNegative from "utils/getNegative";
import getGoalLocked from "utils/getGoalLocked";
import dashboardTableOrder from "utils/dashboardTableOrder";

const allMetricData = allMetrics();
const ageKeyOrder = ["18-24", "25-34", "35-44", "45-54", "55-64", "65+", "unknown"];
const dayKeyOrder = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
const hourKeyOrder = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
];
class PPCDashboardVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlatform: "google",
    };
  }

  handlePlatform = (p) => {
    this.setState({ selectedPlatform: p });
  };

  generateDashboardSection(section, cc_data, dashboard, p) {
    const metricData = allMetricData["metricData"];
    let date = this.props.date ? moment(this.props.date) : moment();
    let month = date.format("MMM");
    let year = date.year();

    if (section.metrics_data) {
      const renderArray = dashboardTableOrder("ppc", Object.keys(section.metrics_data));

      switch (section.name) {
        case "goalsAndProjections":
          let goals = this.props.goals;
          return (
            <>
              <Row xs={1} sm={2} md={5} className="justify-content-center">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                  const current = jsDig([dashboard, metricKey, "raw"], cc_data);
                  const goal = parseFloat(jsDig([dashboard, year, month, camelCase(metricKey)], goals));
                  const projected = jsDig([dashboard, metricKey, "projected"], cc_data);
                  const negative = getNegative(section.name, metricKey, projected - goal, cc_data);
                  const goalLocked = getGoalLocked(date, metricKey);
                  if (metricKey) {
                    if (jsDig([dashboard, metricKey, "raw"], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        let Formatter = GetFormatter({ metricName: metricKey });
                        return (
                          <Col key={index}>
                            <ChartGoal
                              metricName={metricShortened}
                              current={current}
                              goal={goal}
                              projected={projected}
                              formatter={Formatter}
                              negative={negative}
                              goalLocked={goalLocked}
                              baseCurrency={this.props.base_currency}
                              displayCurrency={this.props.display_currency}
                            />
                          </Col>
                        );
                      }
                    } else {
                      return (
                        <p className="text-danger" key={index}>
                          {metricKey} was not found in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </Row>
            </>
          );
        case "primaryKpiCharts":
          return (
            <Row sm={1} md={2} className="justify-content-center">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                const metricTitle = jsDig([metricName, "name", "title"], metricData);
                const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                if (metricKey) {
                  if (jsDig([dashboard, "metrics_by_months", metricKey], cc_data) != null) {
                    if (section.metrics_data[metricName] == "1") {
                      let Formatter = GetFormatter({ metricName: metricKey, tick: true });
                      return (
                        <Col className="mb-4" key={index}>
                          <ChartLine
                            metricName={metricShortened}
                            currentYear={jsDig([dashboard, "metrics_by_months", metricKey, 0, "year"], cc_data)}
                            currentYearData={jsDig([dashboard, "metrics_by_months", metricKey, 0, "data"], cc_data)}
                            previousYear={jsDig([dashboard, "metrics_by_months", metricKey, 1, "year"], cc_data)}
                            previousYearData={jsDig([dashboard, "metrics_by_months", metricKey, 1, "data"], cc_data)}
                            tickFormatter={Formatter}
                            baseCurrency={this.props.base_currency}
                            displayCurrency={this.props.display_currency}
                          />
                        </Col>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricKey} was not found in metrics_by_month in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}
            </Row>
          );
        case "primaryKpiTables":
          let metricTitles = [];
          return (
            <Row sm={1} className="justify-content-center">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                const metricTitle = jsDig([metricName, "name", "title"], metricData);
                const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                if (metricKey) {
                  metricTitles.push(metricKey);
                  if (jsDig([dashboard, "metrics_2_years", metricKey], cc_data) == null) {
                    return (
                      <p className="text-danger" key={index}>
                        {metricKey} was not found in metrics_2_years in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}
              <Col className="mb-4">
                <MetricTable
                  table={jsDig([dashboard, "metrics_2_years"], cc_data)}
                  client={this.props.client_name}
                  headerOrder={metricTitles}
                  date={this.props.date}
                  scrollMessage={true}
                  responsive={true}
                  userDefaultView={jsDig(["user", "table_view_preference"], this.props)}
                  baseCurrency={this.props.base_currency}
                  displayCurrency={this.props.display_currency}
                  ppc
                />
              </Col>
            </Row>
          );
        case "allKpisVsPreviousYear":
          return (
            <>
              <div className="metric-blocks">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  const metricTitle = jsDig([metricName, "name", "title"], metricData);
                  const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                  if (metricKey) {
                    if (jsDig([dashboard, metricKey], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        let Formatter = GetFormatter({ metricName: metricKey });
                        const negative = getNegative(section.name, metricKey, jsDig([dashboard, metricKey, "projected_yy"], cc_data));

                        return (
                          <KPIMetricBlock
                            metricName={metricShortened}
                            metric={
                              <Formatter
                                value={jsDig([dashboard, metricKey, "projected"], cc_data)}
                                client={this.props.client_name}
                                baseCurrency={this.props.base_currency}
                                displayCurrency={this.props.display_currency}
                              />
                            }
                            yy={<MetricFormatter.YY value={jsDig([dashboard, metricKey, "projected_yy"], cc_data)} />}
                            negative={negative}
                            key={index}
                          />
                        );
                      }
                    } else {
                      return (
                        <p className="text-danger d-inline-block" key={index}>
                          {metricKey} was not found in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger d-inline-block" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </div>
            </>
          );
        case "campaignGroups":
          const groupOrder = this.props.campaign_group_order ? this.props.campaign_group_order : [];
          return (
            <>
              {groupOrder.map((group_id, index) => {
                let metricTitles = [];
                const campaignGroup = this.props.campaign_groups.find((group) => group.id == group_id);
                if (campaignGroup) {
                  return (
                    <Row sm={1} className="justify-content-center" key={index}>
                      <h4 className="text-center">{campaignGroup.name}</h4>
                      {renderArray.map((metricName, index) => {
                        const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                        const metricTitle = jsDig([metricName, "name", "title"], metricData);
                        const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                        if (metricKey) {
                          metricTitles.push(metricKey);
                          if (jsDig([group_id, "metrics_2_years", metricKey], cc_data) == null) {
                            return (
                              <p className="text-danger" key={index}>
                                {metricKey} was not found in metrics_2_years in cc_data for campaign group {group_id}
                              </p>
                            );
                          }
                        } else {
                          return (
                            <p className="text-danger" key={index}>
                              {metricName} not defined in metricData.json
                            </p>
                          );
                        }
                      })}
                      <Col className="mb-4">
                        <MetricTable
                          table={jsDig([group_id, "metrics_2_years"], cc_data)}
                          client={this.props.client_name}
                          headerOrder={metricTitles}
                          date={this.props.date}
                          scrollMessage={true}
                          responsive={true}
                          userDefaultView={jsDig(["user", "table_view_preference"], this.props)}
                          baseCurrency={this.props.base_currency}
                          displayCurrency={this.props.display_currency}
                          ppc
                        />
                      </Col>
                    </Row>
                  );
                }
              })}
            </>
          );
        case "spendAllocation":
          let metricsEnabled = [];
          if (jsDig([dashboard, "spend", "raw"], cc_data) > 0 && this.state.selectedPlatform === "all") {
            return (
              <>
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  if (metricKey) {
                    if (jsDig([dashboard, metricKey], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        metricsEnabled.push(metricKey);
                      }
                    } else {
                      return (
                        <p className="text-danger" key={index}>
                          {metricKey} was not found in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}

                <Row xs={1} sm={1} md={3} className="justify-content-left">
                  <Col>
                    <div className="spend-allocation-module" style={{ backgroundColor: "#EEE" }}>
                      <h4>By Platform</h4>
                      <ChartPie
                        data={jsDig([dashboard, "metrics_by_platform"], cc_data)}
                        metricsEnabled={metricsEnabled}
                        id="video-spend-by-platform"
                        baseCurrency={this.props.base_currency}
                        displayCurrency={this.props.display_currency}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="spend-allocation-module" style={{ backgroundColor: "#EEE" }}>
                      <h4>By Device</h4>
                      <ChartPie
                        data={jsDig([dashboard, "metrics_by_device"], cc_data)}
                        metricsEnabled={metricsEnabled}
                        id="video-spend-by-device"
                        baseCurrency={this.props.base_currency}
                        displayCurrency={this.props.display_currency}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="spend-allocation-module" style={{ backgroundColor: "#EEE" }}>
                      <h4>By Gender</h4>
                      <ChartPie
                        data={jsDig([dashboard, "metrics_by_gender"], cc_data)}
                        metricsEnabled={metricsEnabled}
                        id="video-spend-by-gender"
                        baseCurrency={this.props.base_currency}
                        displayCurrency={this.props.display_currency}
                      />
                    </div>
                  </Col>
                </Row>
                <Row sm={1} md={2}>
                  <Col xs={12}>
                    <div className="spend-allocation-module mt-4" style={{ backgroundColor: "#EEE" }}>
                      <h4>By Age</h4>
                      <ChartBar
                        data={jsDig([dashboard, "metrics_by_age"], cc_data)}
                        order={ageKeyOrder}
                        metricsEnabled={metricsEnabled}
                        id="video-spend-by-age"
                      />
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div className="spend-allocation-module mt-4" style={{ backgroundColor: "#EEE" }}>
                      <h4>By Day-of-the-Week</h4>
                      <ChartBar
                        data={jsDig([dashboard, "metrics_by_day"], cc_data)}
                        order={dayKeyOrder}
                        metricsEnabled={metricsEnabled}
                        id="video-spend-by-day"
                        baseCurrency={this.props.base_currency}
                        displayCurrency={this.props.display_currency}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="spend-allocation-module mt-4" style={{ backgroundColor: "#EEE" }}>
                      <h4>By Time-of-Day</h4>
                      <ChartBar
                        data={jsDig([dashboard, "metrics_by_hour"], cc_data)}
                        order={hourKeyOrder}
                        metricsEnabled={metricsEnabled}
                        id="video-spend-by-hour"
                        baseCurrency={this.props.base_currency}
                        displayCurrency={this.props.display_currency}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="spend-allocation-module mt-4" style={{ backgroundColor: "#EEE" }}>
                      <h4 className="mb-4">By Location</h4>
                      <ChartLocation
                        data={jsDig([dashboard, "metrics_by_state"], cc_data)}
                        metricsEnabled={metricsEnabled}
                        id="video-spend-by-state"
                        baseCurrency={this.props.base_currency}
                        displayCurrency={this.props.display_currency}
                      />
                    </div>
                  </Col>
                </Row>
              </>
            );
          } else {
            return <p>No spend data.</p>;
          }
        default:
          return <h4 className="text-danger">{section.name} is not a valid section name for this dashboard</h4>;
      }
    }
  }

  render() {
    const allPlatforms = Object.keys(jsDig(["cc_data"], this.props));
    const platformCount = allPlatforms.length - 1;
    const uniquePlatforms = Array.from(Object.keys(jsDig(["cc_data"], this.props)));
    const svgList = {
      google: (
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="25px" height="25px">
            <path
              fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
            />
            <path
              fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
            />
            <path
              fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
            />
            <path
              fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
            />
          </svg>
          {platformCount >= 2 ? <span className="pl-3">Google only</span> : <span className="pl-3">Google</span>}
          <span>
            <i className="fas fa-angle-down"></i>
          </span>
        </div>
      ),
      microsoft: (
        <div className="pl-3">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="25px" height="25px">
            <path fill="#ff5722" d="M6 6H22V22H6z" transform="rotate(-180 14 14)" />
            <path fill="#4caf50" d="M26 6H42V22H26z" transform="rotate(-180 34 14)" />
            <path fill="#ffc107" d="M26 26H42V42H26z" transform="rotate(-180 34 34)" />
            <path fill="#03a9f4" d="M6 26H22V42H6z" transform="rotate(-180 14 34)" />
          </svg>
          {platformCount >= 2 ? <span className="pl-3">Microsoft only</span> : <span className="pl-3">Microsoft</span>}
          <span>
            <i className="fas fa-angle-down"></i>
          </span>
        </div>
      ),
      bing: (
        <div className="pl-3">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="25px" height="25px">
            <path fill="#ff5722" d="M6 6H22V22H6z" transform="rotate(-180 14 14)" />
            <path fill="#4caf50" d="M26 6H42V22H26z" transform="rotate(-180 34 14)" />
            <path fill="#ffc107" d="M26 26H42V42H26z" transform="rotate(-180 34 34)" />
            <path fill="#03a9f4" d="M6 26H22V42H6z" transform="rotate(-180 14 34)" />
          </svg>
          {platformCount >= 2 ? <span className="pl-3">Microsoft only</span> : <span className="pl-3">Microsoft</span>}
          <span>
            <i className="fas fa-angle-down"></i>
          </span>
        </div>
      ),
      facebook: (
        <div className="pl-3">
          <svg width="25" height="25" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="16" fill="#4267B2" />
            <path
              d="M24.16 11.0933H26.6667V6.85333C25.453 6.72713 24.2336 6.66482 23.0134 6.66667C19.3867 6.66667 16.9067 8.88 16.9067 12.9333V16.4267H12.8134V21.1733H16.9067V33.3333H21.8134V21.1733H25.8934L26.5067 16.4267H21.8134V13.4C21.8134 12 22.1867 11.0933 24.16 11.0933Z"
              fill="#FAFAFA"
            />
          </svg>
          {platformCount >= 2 ? <span className="pl-3">Facebook only</span> : <span className="pl-3">Facebook</span>}
          <span>
            <i className="fas fa-angle-down"></i>
          </span>
        </div>
      ),
      tiktok: (
        <div className="pl-3">
          <svg width="25" height="25" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="16" fill="#202020" />
            <g clip-path="url(#clip0_301_49)">
              <path
                d="M25.0621 16.6418C26.594 17.7462 28.4707 18.396 30.4976 18.396V14.4625C30.1139 14.4626 29.7314 14.4222 29.3561 14.342V17.4382C27.3293 17.4382 25.4529 16.7885 23.9207 15.6842V23.7114C23.9207 27.7271 20.6928 30.9822 16.7114 30.9822C15.2258 30.9822 13.845 30.5293 12.698 29.7524C14.0071 31.1024 15.8328 31.9399 17.8526 31.9399C21.8343 31.9399 25.0622 28.6848 25.0622 24.669V16.6418H25.0621ZM26.4703 12.6733C25.6874 11.8107 25.1733 10.696 25.0621 9.46355V8.95764H23.9804C24.2527 10.524 25.1815 11.8622 26.4703 12.6733ZM15.2162 26.671C14.7788 26.0926 14.5424 25.385 14.5435 24.6574C14.5435 22.8209 16.0198 21.3317 17.8413 21.3317C18.1807 21.3315 18.5181 21.3841 18.8417 21.4875V17.4661C18.4636 17.4138 18.0821 17.3916 17.7007 17.3998V20.5299C17.377 20.4263 17.0394 20.3738 16.6998 20.3741C14.8784 20.3741 13.4021 21.8631 13.4021 23.6999C13.4021 24.9987 14.14 26.1232 15.2162 26.671Z"
                fill="#FF004F"
              />
              <path
                d="M23.9206 15.6841C25.453 16.7884 27.3293 17.4382 29.356 17.4382V14.3419C28.2247 14.0989 27.2232 13.5027 26.4702 12.6733C25.1813 11.8621 24.2526 10.5239 23.9804 8.95764H21.1391V24.6688C21.1326 26.5004 19.6587 27.9834 17.8412 27.9834C16.7702 27.9834 15.8186 27.4686 15.2161 26.6709C14.14 26.1232 13.402 24.9987 13.402 23.7C13.402 21.8634 14.8783 20.3742 16.6997 20.3742C17.0487 20.3742 17.3851 20.429 17.7006 20.5299V17.3998C13.7891 17.4814 10.6433 20.7046 10.6433 24.6689C10.6433 26.6478 11.4267 28.4418 12.6981 29.7526C13.8451 30.5293 15.2258 30.9824 16.7115 30.9824C20.693 30.9824 23.9207 27.727 23.9207 23.7114V15.6842L23.9206 15.6841Z"
                fill="#FAFAFA"
              />
              <path
                d="M29.356 14.3418V13.5048C28.3358 13.5063 27.3357 13.2182 26.4702 12.6733C27.2364 13.5193 28.2453 14.1026 29.356 14.342V14.3418ZM23.9802 8.95752C23.9543 8.80786 23.9343 8.6572 23.9205 8.5059V8H19.9973V23.7113C19.9911 25.5428 18.5173 27.0258 16.6996 27.0258C16.1843 27.0266 15.6761 26.905 15.2159 26.671C15.8185 27.4686 16.7701 27.9833 17.841 27.9833C19.6585 27.9833 21.1325 26.5004 21.1389 24.6688V8.9576H23.9802V8.95752ZM17.7007 17.3997V16.5085C17.3729 16.4633 17.0424 16.4407 16.7115 16.4408C12.7296 16.4408 9.50183 19.696 9.50183 23.7113C9.50183 26.2287 10.7704 28.4473 12.6981 29.7524C11.4267 28.4416 10.6433 26.6476 10.6433 24.6687C10.6433 20.7046 13.789 17.4812 17.7007 17.3997Z"
                fill="#00F2EA"
              />
            </g>
            <defs>
              <clipPath id="clip0_301_49">
                <rect width="21" height="24" fill="white" transform="translate(9.5 8)" />
              </clipPath>
            </defs>
          </svg>
          <span className="pl-3">TikTok Only</span>
          <span>
            <i className="fas fa-angle-down"></i>
          </span>
        </div>
      ),
      all: (
        <div className="pl-3">
          <svg width="25" height="25" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="16" fill="#2C345B" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10H17C17.5304 10 18.0391 10.2107 18.4142 10.5858C18.7893 10.9609 19 11.4696 19 12V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H12C11.4696 19 10.9609 18.7893 10.5858 18.4142C10.2107 18.0391 10 17.5304 10 17V12C10 11.4696 10.2107 10.9609 10.5858 10.5858ZM17 12H12V17H17V12ZM21.5858 10.5858C21.9609 10.2107 22.4696 10 23 10H28C28.5304 10 29.0391 10.2107 29.4142 10.5858C29.7893 10.9609 30 11.4696 30 12V17C30 17.5304 29.7893 18.0391 29.4142 18.4142C29.0391 18.7893 28.5304 19 28 19H23C22.4696 19 21.9609 18.7893 21.5858 18.4142C21.2107 18.0391 21 17.5304 21 17V12C21 11.4696 21.2107 10.9609 21.5858 10.5858ZM28 12H23V17H28V12ZM10.5858 21.5858C10.9609 21.2107 11.4696 21 12 21H17C17.5304 21 18.0391 21.2107 18.4142 21.5858C18.7893 21.9609 19 22.4696 19 23V28C19 28.5304 18.7893 29.0391 18.4142 29.4142C18.0391 29.7893 17.5304 30 17 30H12C11.4696 30 10.9609 29.7893 10.5858 29.4142C10.2107 29.0391 10 28.5304 10 28V23C10 22.4696 10.2107 21.9609 10.5858 21.5858ZM17 23H12V28H17V23ZM21.5858 21.5858C21.9609 21.2107 22.4696 21 23 21H28C28.5304 21 29.0391 21.2107 29.4142 21.5858C29.7893 21.9609 30 22.4696 30 23V28C30 28.5304 29.7893 29.0391 29.4142 29.4142C29.0391 29.7893 28.5304 30 28 30H23C22.4696 30 21.9609 29.7893 21.5858 29.4142C21.2107 29.0391 21 28.5304 21 28V23C21 22.4696 21.2107 21.9609 21.5858 21.5858ZM28 23H23V28H28V23Z"
              fill="#FAFAFA"
            />
          </svg>
          <span className="pl-3">All platforms</span>
          <span>
            <i className="fas fa-angle-down"></i>
          </span>
        </div>
      ),
    };

    let allIcon = require("images/pacing/all-platforms.svg");
    allIcon = <img className="px-4 d-lg-inline-block d-block  my-1" src={`/datapulse${allIcon}`} />;
    let googleIcon = require("images/pacing/icons-google.svg");
    googleIcon = <img className="px-4 d-lg-inline-block d-block  my-1" src={`/datapulse${googleIcon}`} />;
    let microsoftIcon = require("images/pacing/icons-microsoft.svg");
    microsoftIcon = <img className="px-4 d-lg-inline-block d-block my-1" src={`/datapulse${microsoftIcon}`} />;
    let facebookIcon = require("images/pacing/facebook-logo.svg");
    facebookIcon = <img className="px-4 d-lg-inline-block d-block my-1" src={`/datapulse${facebookIcon}`} />;
    let allPlatformIcon = require("images/pacing/all-platforms.svg");
    allPlatformIcon = <img className="px-4 d-lg-inline-block d-block my-1" src={`/datapulse${allPlatformIcon}`} />;
    let tiktokIcon = require("images/pacing/tiktok-logo.svg");
    tiktokIcon = <img className="px-4 d-lg-inline-block d-block my-1" src={`/datapulse${tiktokIcon}`} />;

    const dashboard = this.props.selectedDashboard;
    let cc_data = this.props.cc_data[this.state.selectedPlatform];

    const sectionList = jsDig(["metricsByDashboard", "video", "sections"], allMetricData);
    const defaultMetrics = jsDig(["metricsByDashboard", "video", "defaults", this.props.client_type], allMetricData);
    let dashboardsEnable = false;
    const dashboardOrder =
      jsDig([dashboard], this.props.dashboard_order) && jsDig([dashboard], this.props.dashboard_order).length > 0
        ? jsDig([dashboard], this.props.dashboard_order)
        : Object.keys(sectionList).map((sectionName) => {
            let defaultMetricsData = defaultMetrics[sectionName] ? Object.keys(defaultMetrics[sectionName]) : [];
            return {
              name: sectionName,
              enabled: true,
              metrics_data: defaultMetricsData.reduce((sum, item) => {
                sum[item] = "1";
                return sum;
              }, {}),
            };
          });

    if (this.props.enabled) {
      if (jsDig([dashboard, "date"], cc_data)) {
        return (
          <>
            <div className="dropdown-div">
              <div>Select Platform:</div>
              <div id={`Video - summary-platform-dd`} className="outter-button platforms-dropdown mb-4 mb-lg-0 ml-lg-4 ml-0">
                <button
                  className="btn icon-list-platform "
                  type="button"
                  data-toggle="dropdown"
                  data-display="static"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <div className="inner-button-platforms">{svgList[this.state.selectedPlatform]}</div>
                </button>
                <ul className="dropdown-menu platform-ul" aria-labelledby="dropdownMenuButton">
                  {Object.keys(this.props["cc_data"])
                    .sort((a, b) => (b === "all") - (a === "all"))
                    .filter((el) => (platformCount < 2 ? el !== "all" : el))
                    .map((platform, index) => {
                      let capitalized = platform.charAt(0).toUpperCase() + platform.slice(1);
                      console.log(capitalized);
                      capitalized = capitalized == "Bing" ? "Microsoft" : capitalized;
                      const iconGraphic =
                        platform == "google"
                          ? googleIcon
                          : platform === "microsoft" || platform == "bing"
                          ? microsoftIcon
                          : platform === "facebook"
                          ? facebookIcon
                          : platform === "tiktok"
                          ? tiktokIcon
                          : allIcon;
                      return (
                        <li
                          onClick={(e) => this.handlePlatform(platform)}
                          className={this.state.selectedPlatform == platform ? "icon-selected icon-li" : "icon-li"}
                          key={`Video + ${index}`}>
                          {iconGraphic} {capitalized} {platform === "all" ? "platforms" : platform !== "all" && platformCount >= 2 ? "only" : ""}
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>

            {dashboardOrder.map((dashboardSection, index) => {
              const sectionData = sectionList[dashboardSection.name];
              if (dashboardSection.enabled) {
                dashboardsEnable = true;
                return (
                  <BlueIndentedSection key={index} ppcDash={true} sectionTitle={sectionData.name.title}>
                    {this.generateDashboardSection(dashboardSection, this.props.cc_data[this.state.selectedPlatform], dashboard, this.state.selectedPlatform)}
                  </BlueIndentedSection>
                );
              }
            })}
            {!dashboardsEnable &&
              (this.props.user_is_employee ? (
                <p>You have not enabled any sections for this dashboard yet. Click the configure dashboard button above to set up your dashboard.</p>
              ) : (
                <p>No sections of this dashboard are currently enabled. Please contact your account representatives if you would like to this view.</p>
              ))}
          </>
        );
      } else {
        return (
          <>
            <div className="dropdown-div">
              <div>Select Platform:</div>
              <div id={`Video - summary-platform-dd`} className="outter-button platforms-dropdown mb-4 mb-lg-0 ml-lg-4 ml-0">
                <button
                  className="btn icon-list-platform "
                  type="button"
                  data-toggle="dropdown"
                  data-display="static"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <div className="inner-button-platforms">{svgList[this.state.selectedPlatform]}</div>
                </button>
                <ul className="dropdown-menu platform-ul" aria-labelledby="dropdownMenuButton">
                  {Object.keys(this.props["cc_data"])
                    .sort((a, b) => (b === "all") - (a === "all"))
                    .filter((el) => (platformCount < 2 ? el !== "all" : el))
                    .map((platform, index) => {
                      let capitalized = platform.charAt(0).toUpperCase() + platform.slice(1);
                      const iconGraphic =
                        platform == "google"
                          ? googleIcon
                          : platform === "microsoft"
                          ? microsoftIcon
                          : platform === "facebook"
                          ? facebookIcon
                          : platform === "tiktok"
                          ? tiktokIcon
                          : allIcon;
                      return (
                        <li
                          onClick={(e) => this.handlePlatform(platform)}
                          className={this.state.selectedPlatform == platform ? "icon-selected icon-li" : "icon-li"}
                          key={`Video + ${index}`}>
                          {iconGraphic} {capitalized} {platform === "all" ? "platforms" : platform !== "all" && platformCount >= 2 ? "only" : ""}
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
            <NoData service="video" />;
          </>
        );
      }
    } else {
      return <ServiceDisabled service="video" userIsEmployee={this.props.user_is_employee} />;
    }
  }
}

export default PPCDashboardVideo;
